import { Application } from "Application";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { Expo, Linear, Sine, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { LoadScreenLayout } from "Layouts/LoadScreenLayout";
import * as Constants from "../Data/Constants";

export class LoadScreen extends HLF.LoadScreen implements ReturnType<typeof LoadScreenLayout> {

    public static readonly NAME = "LoadScreen";

    public readonly bg = this.addChild(new LayoutSprite());

    public readonly loaderBase = this.addChild(new LayoutSprite());
    public readonly loaderSpinner = this.addChild(new LayoutSprite());

    public constructor() {
        super();
        this.bg.interactive = true; // prevent clicks
    }

    public init(pSize: PIXI.Point, pData?: any) {
        LoadScreenLayout.call(this);
        super.init(pSize);
        this.bg.alpha = 0;
    }

    public animateOut(pOnComplete: () => void): void {
        // fade out bg
        TweenLite.to(this.bg, 0.75, {pixi: {alpha: 0}}).eventCallback(Constants.TWEEN_ONCOMPLETE, ()=>{
            super.animateOut(pOnComplete);
        });
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
        // hide loader when loading complete
        TweenLite.to([this.loaderSpinner, this.loaderBase], 0.25, {pixi: {y: this._size.y + this.loaderBase.height / 2}});
    }

    public onLoadProgress(pLoader: PIXI.Loader | {progress: number}, pResource?: {name: string, url: string}, pLoaderIndex: number = 0): void {
        super.onLoadProgress(pLoader);
    }

    public animateIn(pOnComplete: () => void): void {
        TweenLite.to(this.bg, 0.5, {pixi: {alpha: 1}}).eventCallback(Constants.TWEEN_ONCOMPLETE, ()=>{
            super.animateIn(pOnComplete);
        });
        TweenLite.from([this.loaderSpinner, this.loaderBase], 0.25, {pixi: {y: this._size.y + this.loaderBase.height / 2}});
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        const degreesPerSecond = 360;
        this.loaderSpinner.angle += pDeltaTime * degreesPerSecond;
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
    }
}
